import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AuthGuard } from "./components/AuthGuard";
import { Bodyweight } from "./pages/Bodyweight";
import { Dashboard } from "./pages/Dashboard";
import { ExerciseHistory } from "./pages/ExerciseHistory";
import { Exercises } from "./pages/Exercises";
import { Login } from "./pages/Login";
import { ProgramDetail } from "./pages/ProgramDetail";
import { Programs } from "./pages/Programs";
import { WorkoutDetail } from "./pages/WorkoutDetail";
import { Workouts } from "./pages/Workouts";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/exercises"
            element={
              <AuthGuard>
                <Exercises />
              </AuthGuard>
            }
          />
          <Route
            path="/exercises/:id/history"
            element={
              <AuthGuard>
                <ExerciseHistory />
              </AuthGuard>
            }
          />
          <Route
            path="/programs"
            element={
              <AuthGuard>
                <Programs />
              </AuthGuard>
            }
          />
          <Route
            path="/programs/:id"
            element={
              <AuthGuard>
                <ProgramDetail />
              </AuthGuard>
            }
          />
          <Route
            path="/workouts"
            element={
              <AuthGuard>
                <Workouts />
              </AuthGuard>
            }
          />
          <Route
            path="/workouts/:id"
            element={
              <AuthGuard>
                <WorkoutDetail />
              </AuthGuard>
            }
          />
          <Route
            path="/bodyweight"
            element={
              <AuthGuard>
                <Bodyweight />
              </AuthGuard>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="*"
            element={
              <AuthGuard>
                <Navigate to="/dashboard" replace />
              </AuthGuard>
            }
          />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
